(function () {
  /* MOBILE / TABLET ONLY — desktop is locked in rb-reviews-carousel.js (Pre-Mobile V1). */
  function isMobileReviewsViewport() {
    return window.matchMedia('(max-width: 1199px)').matches;
  }
  if (!isMobileReviewsViewport()) return;

  var YOTPO_APP_KEY = 'Ioh4q2i1hYPxfsXa70UJV30ezP7GCp6PGQluCzib';
  var REVIEWS_FETCH_COUNT = 30;
  var THUMB_MIN_WIDTH = 56;
  var yotpoWidgetsInitRequested = false;

  function killReadyReviewCarousels() {
    document.querySelectorAll('.rb-reviews__yotpo').forEach(function (el) {
      if (typeof el._rbKillYotpoMotion === 'function') {
        el._rbKillYotpoMotion();
      }
    });
  }

  function patchYotpoInitOnce() {
    if (window._rbYotpoInitPatched) return;
    window._rbYotpoInitPatched = true;

    var poll = window.setInterval(function () {
      if (!window.yotpo) return;
      window.clearInterval(poll);

      if (typeof window.yotpo.initWidgets === 'function') {
        var originalInit = window.yotpo.initWidgets.bind(window.yotpo);
        window.yotpo.initWidgets = function () {
          var result = originalInit.apply(window.yotpo, arguments);
          window.setTimeout(killReadyReviewCarousels, 0);
          window.setTimeout(killReadyReviewCarousels, 400);
          window.setTimeout(killReadyReviewCarousels, 1500);
          return result;
        };
      }

      if (Array.isArray(window.yotpo.callbacks)) {
        window.yotpo.callbacks.push(killReadyReviewCarousels);
      }
    }, 100);
  }

  patchYotpoInitOnce();

  function refreshRbReviewsYotpo() {
    if (yotpoWidgetsInitRequested) return;
    if (!window.yotpo || typeof window.yotpo.initWidgets !== 'function') return;
    yotpoWidgetsInitRequested = true;
    try {
      window.yotpo.initWidgets();
    } catch (error) {
      /* Yotpo can throw on mobile — never block our carousel */
      yotpoWidgetsInitRequested = false;
    }
  }

  function initRbReviewsRoot(root) {
    if (!root) return;
    if (root.dataset.rbReviewsNative === 'true') return;
    if (root.dataset.rbReviewsRootInit === '1') return;
    root.dataset.rbReviewsRootInit = '1';

    var GAP = 18;
    var AUTOPLAY_MS = 5000;
    var ANIMATION_MS = 450;
    var resizeTimer;
    var autoplayTimer;
    var userDragging = false;
    var lastLogicalIndex = 0;

    function getState(el) {
      if (!el._rbCarouselState) {
        el._rbCarouselState = {
          index: 0,
          step: 0,
          slideWidth: 0,
          perView: 1,
          gap: GAP,
          animating: false,
        };
      }
      return el._rbCarouselState;
    }

    function perViewFor(width) {
      if (width >= 900) return 4;
      if (width >= 640) return 2;
      return 1;
    }

    function getShell(el) {
      return el.querySelector('[data-rb-reviews-shell]');
    }

    function getTrack(el) {
      var shell = getShell(el);
      return shell ? shell.querySelector('.glide__track') : null;
    }

    function getSlidesEl(el) {
      var shell = getShell(el);
      return shell ? shell.querySelector('.glide__slides') : null;
    }

    function getRealSlides(el) {
      var shell = getShell(el);
      return shell ? shell.querySelectorAll('.glide__slide:not(.glide__slide--clone)') : [];
    }

    function hideYotpoHosts(el) {
      el.querySelectorAll('.yotpo-widget-instance, [data-yotpo-instance-id]').forEach(function (yotpoHost) {
        if (yotpoHost.closest('[data-rb-reviews-shell]')) return;
        yotpoHost.setAttribute('hidden', '');
        yotpoHost.style.setProperty('display', 'none', 'important');
      });
    }

    function trackWidth(el) {
      var track = getTrack(el);
      if (!track) return 0;
      /* clientWidth avoids subpixel round-up that clips the last card border */
      var w = track.clientWidth || Math.round(track.getBoundingClientRect().width);
      if (w > 0) return w;
      var shell = getShell(el);
      if (shell) {
        w = shell.clientWidth || Math.round(shell.getBoundingClientRect().width);
        if (w > 0) return w;
      }
      w = el.clientWidth || Math.round(el.getBoundingClientRect().width);
      if (w > 0) return w;
      return Math.round(document.documentElement.clientWidth) || 0;
    }

    function getCarouselMetrics(el) {
      var width = trackWidth(el);
      var perView = perViewFor(width);
      if (!width || !perView) return null;

      var totalGap = GAP * (perView - 1);
      /* −1px so the furthest-right card border isn’t clipped by overflow:hidden */
      var slideWidth = Math.floor((width - totalGap - 1) / perView);
      if (slideWidth < 1) return null;

      return {
        perView: perView,
        trackWidth: width,
        gap: GAP,
        slideWidth: slideWidth,
        step: slideWidth + GAP,
      };
    }

    function getMaxIndex(el) {
      var metrics = getCarouselMetrics(el);
      if (!metrics) return 0;
      return Math.max(0, getRealSlides(el).length - metrics.perView);
    }

    function getWrap(el) {
      return el.closest('.rb-reviews__yotpo-wrap');
    }

    function getScrollbarEls(el) {
      var wrap = getWrap(el);
      if (!wrap) return null;
      return {
        bar: wrap.querySelector('[data-rb-reviews-scrollbar]'),
        track: wrap.querySelector('[data-rb-reviews-track]'),
        thumb: wrap.querySelector('[data-rb-reviews-thumb]'),
      };
    }

    function canShowScrollbar(el) {
      var metrics = getCarouselMetrics(el);
      if (!metrics) return false;
      return getRealSlides(el).length > metrics.perView;
    }

    function revealScrollbarBar(ui) {
      if (!ui || !ui.bar) return;
      ui.bar.hidden = false;
      ui.bar.removeAttribute('hidden');
      ui.bar.style.setProperty('display', 'block', 'important');
      ui.bar.style.setProperty('visibility', 'visible', 'important');
    }

    function getScrollbarTrackWidth(el, ui) {
      if (ui && ui.track) {
        var measured = Math.round(ui.track.getBoundingClientRect().width);
        if (measured > 0) return measured;
      }

      var carouselTrackWidth = trackWidth(el);
      if (carouselTrackWidth > 0) return carouselTrackWidth;

      var wrap = getWrap(el);
      if (wrap) {
        var wrapWidth = Math.round(wrap.getBoundingClientRect().width);
        if (wrapWidth > 0) return wrapWidth;
      }

      return 0;
    }

    function getScrollbarMetrics(el, index) {
      var ui = getScrollbarEls(el);
      if (!ui || !ui.track || !ui.thumb) return null;

      var metrics = getCarouselMetrics(el);
      if (!metrics) return null;

      var slideCount = getRealSlides(el).length;
      var maxIndex = Math.max(0, slideCount - metrics.perView);
      var trackWidthPx = getScrollbarTrackWidth(el, ui);
      if (!trackWidthPx) return null;

      var thumbWidth = Math.max(
        THUMB_MIN_WIDTH,
        Math.round(trackWidthPx * (metrics.perView / Math.max(slideCount, 1)))
      );
      var maxOffset = Math.max(0, trackWidthPx - thumbWidth);
      var progress = maxIndex > 0 ? index / maxIndex : 0;
      var offset = Math.max(0, Math.min(1, progress)) * maxOffset;

      return {
        ui: ui,
        thumbWidth: thumbWidth,
        offset: offset,
      };
    }

    function updateScrollbar(el, index, animate, options) {
      options = options || {};
      var ui = getScrollbarEls(el);
      if (!ui || !ui.bar || !ui.track || !ui.thumb) return;

      if (!canShowScrollbar(el)) {
        ui.bar.hidden = true;
        ui.bar.setAttribute('hidden', '');
        return;
      }

      revealScrollbarBar(ui);

      var data = getScrollbarMetrics(el, index);
      if (!data) return;

      ui.track.style.setProperty('width', '100%', 'important');
      if (data.ui.thumb.style.width !== data.thumbWidth + 'px') {
        data.ui.thumb.style.width = data.thumbWidth + 'px';
      }

      var durationMs = options.durationMs != null ? options.durationMs : ANIMATION_MS;
      var easing = options.easing || 'cubic-bezier(0.22, 0.61, 0.36, 1)';
      var nextTransform = 'translate3d(' + data.offset + 'px, 0, 0)';

      if (animate) {
        if (data.ui.thumb.style.transform !== nextTransform) {
          data.ui.thumb.style.transition = 'transform ' + (durationMs / 1000) + 's ' + easing;
          data.ui.thumb.style.transform = nextTransform;
        }
      } else {
        data.ui.thumb.style.transition = 'none';
        data.ui.thumb.style.transform = nextTransform;
      }
    }

    function syncScrollbar(el, index, animate, options) {
      updateScrollbar(el, index, animate, options);
      if (animate) return;
      window.requestAnimationFrame(function () {
        updateScrollbar(el, index, false, options);
      });
    }

    function clearScrollbarTransition(el) {
      var ui = getScrollbarEls(el);
      if (!ui || !ui.thumb) return;
      ui.thumb.style.transition = 'none';
    }

    function isInsideRbShell(node) {
      return !!(node && node.closest && node.closest('[data-rb-reviews-shell]'));
    }

    function destroyYotpoMotion(el) {
      /* Never touch our custom shell — it reuses Yotpo/Glide class names */
      el.querySelectorAll('.glide, .glide__track').forEach(function (node) {
        if (isInsideRbShell(node)) return;
        node.style.setProperty('transform', 'none', 'important');
        node.style.setProperty('transition', 'none', 'important');
        node.removeAttribute('data-glide-el');
      });

      el.querySelectorAll('[data-glide-dir], .glide__arrow, .glide__bullets, .glide__bullet').forEach(function (node) {
        if (isInsideRbShell(node)) return;
        node.remove();
      });

      el.querySelectorAll('.glide__slide--clone').forEach(function (clone) {
        if (isInsideRbShell(clone)) return;
        clone.remove();
      });

      el.querySelectorAll('.glide').forEach(function (glideRoot) {
        if (isInsideRbShell(glideRoot)) return;
        var keys = [];
        try {
          keys = Object.getOwnPropertyNames(glideRoot);
        } catch (error) {
          keys = [];
        }
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          var instance = glideRoot[key];
          if (!instance || typeof instance !== 'object') continue;
          if (typeof instance.go !== 'function' && typeof instance.mount !== 'function') continue;

          instance.go = function () {};
          instance.mount = function () {};
          instance.update = function () {};
          instance.run = function () {};
          if (typeof instance.pause === 'function') instance.pause();
          if (typeof instance.disable === 'function') {
            try {
              instance.disable();
            } catch (error) {
              /* Glide builds vary */
            }
          }
          if (instance.settings) {
            instance.settings.autoplay = 0;
            instance.settings.hoverpause = false;
            instance.settings.swipeThreshold = false;
            instance.settings.animationDuration = 0;
          }
        }
      });
    }

    function freezeGlide(el) {
      destroyYotpoMotion(el);
    }

    function readSlidesTranslateX(slidesEl) {
      if (!slidesEl) return 0;
      var transform = window.getComputedStyle(slidesEl).transform;
      if (!transform || transform === 'none') return 0;
      return Math.round(new DOMMatrixReadOnly(transform).m41);
    }

    function markTransformWrite(el) {
      el._rbSuppressTransformLock = true;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          el._rbSuppressTransformLock = false;
        });
      });
    }

    function markSettleCooldown(el) {
      el._rbSettleUntil = Date.now() + 600;
    }

    function isInSettleCooldown(el) {
      return el._rbSettleUntil && Date.now() < el._rbSettleUntil;
    }

    function applySlideLayout(el) {
      var slides = getRealSlides(el);
      var slidesEl = getSlidesEl(el);
      var track = getTrack(el);
      var metrics = getCarouselMetrics(el);
      if (!slides.length || !slidesEl || !track || !metrics) return null;

      var state = getState(el);
      state.perView = metrics.perView;
      state.gap = metrics.gap;
      state.slideWidth = metrics.slideWidth;
      state.step = metrics.step;

      el.style.setProperty('--rb-review-slide-width', metrics.slideWidth + 'px');
      el.style.setProperty('--rb-reviews-carousel-gap', metrics.gap + 'px');

      track.style.setProperty('width', '100%', 'important');
      track.style.setProperty('max-width', '100%', 'important');
      track.style.setProperty('overflow', 'hidden', 'important');
      track.style.setProperty('box-sizing', 'border-box', 'important');
      track.style.setProperty('margin', '0', 'important');
      track.style.setProperty('padding', '0', 'important');

      slidesEl.style.setProperty('display', 'flex', 'important');
      slidesEl.style.setProperty('flex-direction', 'row', 'important');
      slidesEl.style.setProperty('direction', 'ltr', 'important');
      slidesEl.style.setProperty('gap', '0', 'important');
      slidesEl.style.setProperty('margin', '0', 'important');
      slidesEl.style.setProperty('padding', '0', 'important');
      slidesEl.style.setProperty('width', 'max-content', 'important');
      slidesEl.style.setProperty('box-sizing', 'border-box', 'important');
      slidesEl.style.setProperty('transform-origin', 'left center', 'important');

      slides.forEach(function (slide, index) {
        slide.style.setProperty('width', metrics.slideWidth + 'px', 'important');
        slide.style.setProperty('min-width', metrics.slideWidth + 'px', 'important');
        slide.style.setProperty('max-width', metrics.slideWidth + 'px', 'important');
        slide.style.setProperty('flex', '0 0 ' + metrics.slideWidth + 'px', 'important');
        slide.style.setProperty('flex-shrink', '0', 'important');
        slide.style.setProperty('flex-grow', '0', 'important');
        slide.style.setProperty('margin', '0', 'important');
        slide.style.setProperty('padding', '0', 'important');
        slide.style.setProperty('box-sizing', 'border-box', 'important');
        slide.style.setProperty('overflow', 'hidden', 'important');
        slide.style.setProperty(
          'margin-right',
          index < slides.length - 1 ? metrics.gap + 'px' : '0',
          'important'
        );
      });

      return metrics;
    }

    function getOffsetForIndex(el, index) {
      var state = getState(el);
      if (state.step > 0) {
        return Math.round(index * state.step);
      }
      var metrics = getCarouselMetrics(el);
      return metrics ? Math.round(index * metrics.step) : 0;
    }

    function setSlidesTransform(el, index, animate, options) {
      options = options || {};
      var slidesEl = getSlidesEl(el);
      var state = getState(el);
      if (!slidesEl || !state.step) return;

      if (options.freezeGlide) {
        freezeGlide(el);
      }

      var offset = getOffsetForIndex(el, index);
      var durationMs = options.durationMs != null ? options.durationMs : ANIMATION_MS;
      var easing = options.easing || 'linear';

      if (animate) {
        state.animating = true;
        slidesEl.style.setProperty(
          'transition',
          'transform ' + (durationMs / 1000) + 's ' + easing,
          'important'
        );
      } else {
        state.animating = false;
        slidesEl.style.setProperty('transition', 'none', 'important');
      }

      markTransformWrite(el);
      slidesEl.style.setProperty(
        'transform',
        'translate3d(' + (-offset) + 'px, 0px, 0px)',
        'important'
      );
    }

    function clearSlidesTransition(el) {
      var slidesEl = getSlidesEl(el);
      if (!slidesEl) return;
      slidesEl.style.setProperty('transition', 'none', 'important');
    }

    function isTransformAligned(el, index) {
      var expected = -getOffsetForIndex(el, index);
      var current = readSlidesTranslateX(getSlidesEl(el));
      return Math.abs(current - expected) <= 1;
    }

    function setActiveSlide() {
      /* Yotpo listens to active slide changes — do not toggle Glide classes. */
    }

    function revertExternalTransform(el) {
      var slidesEl = getSlidesEl(el);
      if (!slidesEl || isTransformAligned(el, lastLogicalIndex)) return;
      destroyYotpoMotion(el);
      clearSlidesTransition(el);
      markTransformWrite(el);
      slidesEl.style.setProperty(
        'transform',
        'translate3d(' + (-getOffsetForIndex(el, lastLogicalIndex)) + 'px, 0px, 0px)',
        'important'
      );
    }

    function goToIndex(el, targetIndex, animate, options) {
      options = options || {};
      var metrics = null;
      if (options.skipLayout && getState(el).step > 0) {
        metrics = {
          step: getState(el).step,
          perView: getState(el).perView,
          gap: getState(el).gap,
          slideWidth: getState(el).slideWidth,
        };
      } else {
        metrics = applySlideLayout(el);
      }
      if (!metrics) return;

      var maxIndex = getMaxIndex(el);
      targetIndex = Math.max(0, Math.min(maxIndex, Math.round(targetIndex)));
      lastLogicalIndex = targetIndex;
      getState(el).index = targetIndex;

      var durationMs = options.durationMs != null ? options.durationMs : ANIMATION_MS;
      var easing = options.easing || 'linear';
      var motionOpts = {
        freezeGlide: options.freezeGlide != null ? options.freezeGlide : !animate,
        durationMs: durationMs,
        easing: easing,
      };

      setSlidesTransform(el, targetIndex, animate, motionOpts);
      syncScrollbar(el, targetIndex, animate, motionOpts);

      if (animate) {
        var settled = false;
        var slidesEl = getSlidesEl(el);
        var skipDestroy = !!options.skipDestroy;

        function settle() {
          if (settled) return;
          settled = true;
          if (slidesEl) {
            slidesEl.removeEventListener('transitionend', onTransitionEnd);
            slidesEl.style.removeProperty('will-change');
          }
          getState(el).animating = false;
          markSettleCooldown(el);
          clearSlidesTransition(el);
          clearScrollbarTransition(el);
          if (!skipDestroy) destroyYotpoMotion(el);
          queueAutoplay(el);
        }

        function onTransitionEnd(event) {
          if (!slidesEl || event.target !== slidesEl || event.propertyName !== 'transform') return;
          settle();
        }

        if (slidesEl) {
          slidesEl.addEventListener('transitionend', onTransitionEnd);
        }
        window.setTimeout(settle, durationMs + 100);
      }
    }

    function advanceCarousel(el) {
      if (getState(el).animating) return;

      var maxIndex = getMaxIndex(el);
      if (maxIndex === 0) return;

      if (lastLogicalIndex >= maxIndex) {
        goToIndex(el, 0, false);
        queueAutoplay(el, AUTOPLAY_MS);
        return;
      }

      goToIndex(el, lastLogicalIndex + 1, true);
    }

    function layoutCarousel(el) {
      var metrics = getCarouselMetrics(el);
      if (!metrics) {
        window.setTimeout(function () {
          if (getCarouselMetrics(el)) layoutCarousel(el);
        }, 200);
        return;
      }
      var maxIndex = getMaxIndex(el);
      if (lastLogicalIndex > maxIndex) {
        lastLogicalIndex = maxIndex;
      }
      goToIndex(el, lastLogicalIndex, false);
      lockReviewCards(el);
      unlockMobileSwipeSurface(el);
      syncSwipeHint(el);
    }

    function queueAutoplay(el, delayMs) {
      if (el.dataset.rbAutoplay !== '1') return;
      if (autoplayTimer) window.clearTimeout(autoplayTimer);
      autoplayTimer = window.setTimeout(function () {
        if (el.dataset.rbAutoplay !== '1') return;
        if (el.dataset.rbCarouselReady !== '1') {
          queueAutoplay(el, delayMs || AUTOPLAY_MS);
          return;
        }
        if (userDragging || getState(el).animating) {
          queueAutoplay(el, 250);
          return;
        }
        advanceCarousel(el);
      }, typeof delayMs === 'number' ? delayMs : AUTOPLAY_MS);
    }

    function startAutoplay(el) {
      if (el.dataset.rbAutoplay === '1') return;
      el.dataset.rbAutoplay = '1';
      queueAutoplay(el, AUTOPLAY_MS);
    }

    function stopAutoplay(el) {
      el.dataset.rbAutoplay = '0';
      if (autoplayTimer) {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function takeControl(el) {
      destroyYotpoMotion(el);
      hideYotpoHosts(el);
      lockCarouselInteraction(el);
      lastLogicalIndex = 0;
      getState(el).index = 0;

      var slidesEl = getSlidesEl(el);
      if (slidesEl) {
        slidesEl.setAttribute('data-rb-owns-motion', 'true');
      }

      el._rbKillYotpoMotion = function () {
        destroyYotpoMotion(el);
        hideYotpoHosts(el);
        ensureGlideShell(el);
      };

      layoutCarousel(el);
      el.dataset.rbCarouselReady = '1';
      fixReviewTextEntities(el);
      syncScrollbar(el, lastLogicalIndex, false);
      syncSwipeHint(el);
      unlockMobileSwipeSurface(el);
      bindMobileSwipe(el);
      startAutoplay(el);
      bindTransformLock(el);

      if (el._rbYotpoKillTimer) window.clearInterval(el._rbYotpoKillTimer);
      el._rbYotpoKillTimer = window.setInterval(function () {
        if (el.dataset.rbCarouselReady !== '1') return;
        destroyYotpoMotion(el);
        hideYotpoHosts(el);
        if (!getShell(el) || !getSlidesEl(el)) {
          el.dataset.rbGlideBound = '0';
          el.dataset.rbReviewsExpanded = '0';
          el.dataset.rbMobileSwipe = '0';
          el.dataset.rbTransformLock = '0';
          ensureGlideShell(el);
          bindCarousel(el);
        }
      }, 1500);
    }

    function bindTransformLock(el) {
      if (el.dataset.rbTransformLock === '1') return;
      var slidesEl = getSlidesEl(el);
      if (!slidesEl) return;
      el.dataset.rbTransformLock = '1';

      new MutationObserver(function () {
        if (el._rbSuppressTransformLock) return;
        if (userDragging) return;
        if (getState(el).animating) return;
        if (isInSettleCooldown(el)) return;
        if (el.dataset.rbCarouselReady !== '1') return;
        revertExternalTransform(el);
      }).observe(slidesEl, { attributes: true, attributeFilter: ['style'] });
    }

    function getHeaderSummaryEls(el) {
      var container = el.closest('.rb-container');
      if (!container) return null;
      return {
        summary: container.querySelector('[data-rb-reviews-summary]'),
        count: container.querySelector('[data-rb-reviews-header-count]'),
      };
    }

    function formatReviewCount(total) {
      return total.toLocaleString('en-US') + ' Reviews';
    }

    function updateReviewSummary(el, total) {
      var header = getHeaderSummaryEls(el);
      if (!header || !header.summary || !header.count || !total) return;
      header.count.textContent = formatReviewCount(total);
      header.summary.hidden = false;
    }

    function lockReviewCards(el) {
      el.querySelectorAll('.reviews-carousel-card-container').forEach(function (card) {
        card.removeAttribute('data-rb-card-scrollbar');
        card.style.setProperty('pointer-events', 'none', 'important');
        card.style.setProperty('overflow-x', 'hidden', 'important');
        card.style.setProperty('overflow-y', 'hidden', 'important');
        /* pan-y: page scrolls vertically; horizontal left to track JS */
        card.style.setProperty('touch-action', 'pan-y', 'important');
        card.style.setProperty('user-select', 'none', 'important');
        card.style.setProperty('-webkit-user-select', 'none', 'important');
        card.style.setProperty('overscroll-behavior', 'none', 'important');
        card.style.setProperty('scrollbar-width', 'none', 'important');

        card.querySelectorAll('*').forEach(function (child) {
          child.style.setProperty('pointer-events', 'none', 'important');
          child.style.setProperty('user-select', 'none', 'important');
          child.style.setProperty('-webkit-user-select', 'none', 'important');
          child.style.setProperty('touch-action', 'pan-y', 'important');
        });
      });

      el.querySelectorAll('.reviews-carousel-card-container a, .review-product').forEach(function (link) {
        link.style.setProperty('pointer-events', 'none', 'important');
        link.style.setProperty('cursor', 'default', 'important');
      });

      fixReviewTextEntities(el);
    }

    function isMobileReviewsViewport() {
      return window.matchMedia('(max-width: 1199px)').matches;
    }

    function unlockMobileSwipeSurface(el) {
      if (!isMobileReviewsViewport()) return;

      var shell = getShell(el);
      var track = getTrack(el);
      var slidesEl = getSlidesEl(el);
      var wrap = getWrap(el);

      [el, wrap, shell, track, slidesEl].forEach(function (node) {
        if (!node) return;
        node.style.setProperty('pointer-events', 'auto', 'important');
        /* pan-y only: browser vertical scroll; JS owns horizontal flips */
        node.style.setProperty('touch-action', 'pan-y', 'important');
        node.style.setProperty('user-select', 'none', 'important');
        node.style.setProperty('-webkit-user-select', 'none', 'important');
      });

      if (shell) {
        shell.querySelectorAll('.glide, .glide__track, .glide__slides, .glide__slide').forEach(function (node) {
          node.style.setProperty('pointer-events', 'auto', 'important');
          node.style.setProperty('touch-action', 'pan-y', 'important');
          node.style.setProperty('user-select', 'none', 'important');
        });
      }
    }

    function syncSwipeHint(el) {
      var wrap = getWrap(el);
      if (!wrap) return;
      var hint = wrap.querySelector('[data-rb-reviews-hint]');
      if (!hint) return;
      if (isMobileReviewsViewport() && canShowScrollbar(el)) {
        hint.hidden = false;
        hint.removeAttribute('hidden');
      } else {
        hint.hidden = true;
        hint.setAttribute('hidden', '');
      }
    }

    function bindMobileSwipe(el) {
      if (el.dataset.rbMobileSwipe === '1') return;
      el.dataset.rbMobileSwipe = '1';

      var drag = null;
      var SWIPE_RATIO = 0.14;
      var SWIPE_MIN = 26;
      var SWIPE_SNAP_MS = 380;
      var SWIPE_EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';
      var AXIS_SLOP = 8;
      var docListening = false;

      function liveTrack() {
        return getTrack(el);
      }

      function liveSlides() {
        return getSlidesEl(el);
      }

      function currentOffsetPx() {
        var slidesEl = liveSlides();
        if (!slidesEl) return getOffsetForIndex(el, lastLogicalIndex);
        return Math.max(0, -readSlidesTranslateX(slidesEl));
      }

      function setSurfaceTouchAction(value) {
        var track = liveTrack();
        var wrap = getWrap(el);
        [el, wrap, track, liveSlides()].forEach(function (node) {
          if (!node) return;
          node.style.setProperty('touch-action', value, 'important');
        });
      }

      function setSwipingClass(on) {
        document.documentElement.classList.toggle('rb-reviews-swiping', !!on);
      }

      function paintDragOffset(dx) {
        var slidesEl = liveSlides();
        if (!slidesEl || !drag || !drag.locked) return;
        var offset = Math.max(0, Math.min(drag.maxOffset, drag.startOffset - dx));
        drag.currentOffset = offset;
        el._rbSuppressTransformLock = true;
        /* Direct write — 1:1 with the finger (no rAF lag) */
        slidesEl.style.setProperty(
          'transform',
          'translate3d(' + (-offset) + 'px, 0px, 0px)',
          'important'
        );
        if (drag.thumb && drag.step > 0 && drag.maxIndex > 0) {
          var travel = Math.max(0, (drag.thumbTrackWidth || 0) - (drag.thumbWidth || 56));
          var thumbX = Math.round((offset / drag.step / drag.maxIndex) * travel);
          thumbX = Math.max(0, Math.min(travel, thumbX));
          drag.thumb.style.transform = 'translate3d(' + thumbX + 'px, 0, 0)';
        }
      }

      function unbindDoc() {
        if (!docListening) return;
        docListening = false;
        document.removeEventListener('touchmove', onDocTouchMove, true);
        document.removeEventListener('touchend', onDocTouchEnd, true);
        document.removeEventListener('touchcancel', onDocTouchCancel, true);
        document.removeEventListener('pointermove', onDocPointerMove, true);
        document.removeEventListener('pointerup', onDocPointerUp, true);
        document.removeEventListener('pointercancel', onDocPointerCancel, true);
      }

      function bindDoc() {
        if (docListening) return;
        docListening = true;
        document.addEventListener('touchmove', onDocTouchMove, { capture: true, passive: false });
        document.addEventListener('touchend', onDocTouchEnd, true);
        document.addEventListener('touchcancel', onDocTouchCancel, true);
        document.addEventListener('pointermove', onDocPointerMove, { capture: true, passive: false });
        document.addEventListener('pointerup', onDocPointerUp, true);
        document.addEventListener('pointercancel', onDocPointerCancel, true);
      }

      function endDrag(pointerId, cancelled) {
        if (!drag) return;
        if (pointerId != null && drag.pointerId != null && pointerId !== drag.pointerId) return;

        var axis = drag.axis;
        var dx = drag.lastX - drag.startX;
        var wasDragging = !!drag.locked;
        var velocity = drag.velocity || 0;
        var endOffset = typeof drag.currentOffset === 'number' ? drag.currentOffset : drag.startOffset;
        drag = null;
        userDragging = false;
        el._rbSuppressTransformLock = false;
        setSwipingClass(false);
        unbindDoc();
        setSurfaceTouchAction('pan-y');

        if (!wasDragging) {
          startAutoplay(el);
          return;
        }

        var snapOpts = {
          durationMs: SWIPE_SNAP_MS,
          easing: SWIPE_EASING,
          skipLayout: true,
          skipDestroy: true,
          freezeGlide: false,
        };

        var target = lastLogicalIndex;
        if (!(cancelled || axis !== 'x')) {
          var step = getState(el).step || getOffsetForIndex(el, 1) || 200;
          var threshold = Math.max(SWIPE_MIN, Math.round(step * SWIPE_RATIO));
          if (Math.abs(velocity) > 0.45) threshold = Math.max(16, Math.round(threshold * 0.5));
          if (dx <= -threshold || velocity < -0.45) target = lastLogicalIndex + 1;
          else if (dx >= threshold || velocity > 0.45) target = lastLogicalIndex - 1;
        }

        var shouldAnimate = !cancelled && axis === 'x';
        /* Keep transform continuous from finger release — no getComputedStyle / removeProperty hitch */
        var slidesEl = liveSlides();
        if (slidesEl && typeof endOffset === 'number') {
          slidesEl.style.setProperty(
            'transform',
            'translate3d(' + (-endOffset) + 'px, 0px, 0px)',
            'important'
          );
        }
        goToIndex(el, target, shouldAnimate, snapOpts);
        startAutoplay(el);
      }

      function beginWatch(clientX, clientY, pointerId) {
        if (!isMobileReviewsViewport()) return;
        if (getMaxIndex(el) <= 0) return;
        if (!liveSlides()) return;

        if (getState(el).animating) {
          getState(el).animating = false;
          clearSlidesTransition(el);
        }

        var startOffset = currentOffsetPx();
        drag = {
          pointerId: pointerId,
          startX: clientX,
          startY: clientY,
          lastX: clientX,
          lastTime: performance.now(),
          velocity: 0,
          axis: null,
          locked: false,
          startOffset: startOffset,
          currentOffset: startOffset,
          maxOffset: 0,
          maxIndex: 0,
          step: 0,
          thumb: null,
          thumbTrackWidth: 0,
          thumbWidth: 56,
        };
        bindDoc();
      }

      function lockHorizontalDrag() {
        if (!drag) return;
        var state = getState(el);
        var maxIndex = getMaxIndex(el);
        drag.maxIndex = maxIndex;
        drag.maxOffset = getOffsetForIndex(el, maxIndex);
        drag.step = state.step || getOffsetForIndex(el, 1) || 1;

        var ui = getScrollbarEls(el);
        if (ui && ui.thumb && ui.track) {
          drag.thumb = ui.thumb;
          drag.thumbTrackWidth = Math.round(ui.track.getBoundingClientRect().width) || 0;
          drag.thumbWidth = Math.round(ui.thumb.getBoundingClientRect().width) || 56;
          ui.thumb.style.transition = 'none';
        }

        var slidesEl = liveSlides();
        if (slidesEl) {
          slidesEl.style.setProperty('will-change', 'transform');
          clearSlidesTransition(el);
        }

        drag.axis = 'x';
        drag.locked = true;
        userDragging = true;
        el._rbSuppressTransformLock = true;
        setSwipingClass(true);
        stopAutoplay(el);
        setSurfaceTouchAction('none');
      }

      function moveWatch(clientX, clientY, pointerId, event) {
        if (!drag) return;
        if (pointerId != null && drag.pointerId != null && pointerId !== drag.pointerId) return;
        if (!isMobileReviewsViewport()) {
          endDrag(pointerId, true);
          return;
        }

        var now = performance.now();
        var dt = Math.max(1, now - (drag.lastTime || now));
        var instantVx = (clientX - drag.lastX) / dt;
        drag.velocity = drag.velocity * 0.65 + instantVx * 0.35;
        drag.lastTime = now;
        drag.lastX = clientX;

        var dx = clientX - drag.startX;
        var dy = clientY - drag.startY;
        var absDx = Math.abs(dx);
        var absDy = Math.abs(dy);

        if (!drag.axis) {
          if (absDx < AXIS_SLOP && absDy < AXIS_SLOP) return;

          if (absDy > absDx) {
            drag = null;
            userDragging = false;
            unbindDoc();
            return;
          }

          if (absDx < AXIS_SLOP) return;
          lockHorizontalDrag();
        }

        if (drag.axis !== 'x') return;
        if (event && event.cancelable) event.preventDefault();
        paintDragOffset(dx);
      }

      function eventInsideCarousel(event) {
        var node = event.target;
        if (!node) return false;
        if (el.contains(node)) return true;
        var wrap = getWrap(el);
        return !!(wrap && wrap.contains(node));
      }

      function onTouchStart(event) {
        if (!eventInsideCarousel(event)) return;
        if (event.touches.length !== 1) return;
        var touch = event.touches[0];
        beginWatch(touch.clientX, touch.clientY, touch.identifier);
      }

      function onDocTouchMove(event) {
        if (!drag || event.touches.length !== 1) return;
        var touch = event.touches[0];
        moveWatch(touch.clientX, touch.clientY, touch.identifier, event);
      }

      function onDocTouchEnd(event) {
        var id = event.changedTouches && event.changedTouches[0]
          ? event.changedTouches[0].identifier
          : null;
        endDrag(id, false);
      }

      function onDocTouchCancel(event) {
        var id = event.changedTouches && event.changedTouches[0]
          ? event.changedTouches[0].identifier
          : null;
        endDrag(id, true);
      }

      function onPointerDown(event) {
        if (event.pointerType === 'touch') return;
        if (!eventInsideCarousel(event)) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        beginWatch(event.clientX, event.clientY, event.pointerId);
      }

      function onDocPointerMove(event) {
        if (!drag || event.pointerType === 'touch') return;
        moveWatch(event.clientX, event.clientY, event.pointerId, event);
      }

      function onDocPointerUp(event) {
        if (event.pointerType === 'touch') return;
        endDrag(event.pointerId, false);
      }

      function onDocPointerCancel(event) {
        if (event.pointerType === 'touch') return;
        endDrag(event.pointerId, true);
      }

      /* Capture on the carousel root — survives track rebuilds; doc listeners finish the gesture */
      el.addEventListener('touchstart', onTouchStart, { capture: true, passive: true });
      el.addEventListener('pointerdown', onPointerDown, true);

      var wrap = getWrap(el);
      if (wrap && wrap !== el) {
        wrap.addEventListener('touchstart', onTouchStart, { capture: true, passive: true });
        wrap.addEventListener('pointerdown', onPointerDown, true);
      }

      /*
        Fallback: homepage CSS uses pointer-events:none on the wrap. If that wins,
        touches fall through to content below and never hit el. Geometry catch still
        starts a swipe when the finger is over the track.
      */
      function pointOverTrack(clientX, clientY) {
        var track = liveTrack() || el;
        var rect = track.getBoundingClientRect();
        return (
          clientX >= rect.left &&
          clientX <= rect.right &&
          clientY >= rect.top &&
          clientY <= rect.bottom
        );
      }

      document.addEventListener(
        'touchstart',
        function (event) {
          if (drag) return;
          if (!isMobileReviewsViewport()) return;
          if (event.touches.length !== 1) return;
          var touch = event.touches[0];
          if (!pointOverTrack(touch.clientX, touch.clientY)) return;
          beginWatch(touch.clientX, touch.clientY, touch.identifier);
        },
        { capture: true, passive: true }
      );

      document.addEventListener(
        'pointerdown',
        function (event) {
          if (drag) return;
          if (event.pointerType === 'touch') return;
          if (!isMobileReviewsViewport()) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (!pointOverTrack(event.clientX, event.clientY)) return;
          beginWatch(event.clientX, event.clientY, event.pointerId);
        },
        true
      );

      unlockMobileSwipeSurface(el);
    }

    function lockCarouselInteraction(el) {
      if (el.dataset.rbCarouselLocked === '1') {
        lockReviewCards(el);
        unlockMobileSwipeSurface(el);
        return;
      }
      el.dataset.rbCarouselLocked = '1';

      /* Mobile: keep pan-x pan-y so vertical page scroll works over the carousel */
      if (isMobileReviewsViewport()) {
        lockReviewCards(el);
        unlockMobileSwipeSurface(el);
        return;
      }

      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('touch-action', 'none', 'important');
      el.style.setProperty('user-select', 'none', 'important');

      el.querySelectorAll('.glide, .glide__track, .glide__slides, .glide__slide, .yotpo-widget-instance, .yotpo-reviews-carousel-widget-container').forEach(function (node) {
        node.style.setProperty('pointer-events', 'none', 'important');
        node.style.setProperty('touch-action', 'none', 'important');
        node.style.setProperty('user-select', 'none', 'important');
      });

      var wrap = getWrap(el);
      if (wrap) {
        wrap.style.setProperty('pointer-events', 'none', 'important');
        wrap.style.setProperty('touch-action', 'none', 'important');
      }

      lockReviewCards(el);
      unlockMobileSwipeSurface(el);
    }

    function getProductId(root) {
      var widget = root.querySelector('[data-yotpo-product-id]');
      return widget && widget.dataset.yotpoProductId ? widget.dataset.yotpoProductId : '';
    }

    function getReviewsApiUrl(productId) {
      var base = 'https://api.yotpo.com/v1/widget/' + YOTPO_APP_KEY;
      if (productId) {
        return base + '/products/' + encodeURIComponent(productId) + '/reviews.json';
      }
      return base + '/reviews.json';
    }

    function formatReviewDate(isoDate) {
      if (!isoDate) return '';
      var date = new Date(isoDate);
      if (isNaN(date.getTime())) return '';
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var year = String(date.getFullYear()).slice(-2);
      return month + '/' + day + '/' + year;
    }

    function decodeHtmlEntities(value) {
      if (value == null || value === '') return '';
      var decoded = String(value);
      if (decoded.indexOf('&') === -1) return decoded;

      var previous;
      var guard = 0;
      do {
        previous = decoded;
        var textarea = document.createElement('textarea');
        textarea.innerHTML = decoded;
        decoded = textarea.value;
        guard++;
      } while (decoded !== previous && decoded.indexOf('&') !== -1 && guard < 3);

      return decoded;
    }

    function fixReviewTextEntities(el) {
      el.querySelectorAll(
        '.review-title, .review-content, .reviewer-display-name, .review-product-name'
      ).forEach(function (node) {
        var text = node.textContent;
        if (!text || text.indexOf('&') === -1) return;
        var decoded = decodeHtmlEntities(text);
        if (decoded !== text) {
          node.textContent = decoded;
        }
      });
    }

    function buildProductMap(products) {
      var map = {};
      (products || []).forEach(function (product) {
        map[product.id] = product;
        if (product.domain_key) map[product.domain_key] = product;
      });
      return map;
    }

    function updateStarRating(slide, score) {
      var stars = slide.querySelectorAll('.yotpo-star-container svg');
      var filledCount = Math.min(5, Math.max(0, Math.round(Number(score) || 5)));
      for (var i = 0; i < stars.length; i++) {
        var path = stars[i].querySelector('path');
        if (path) {
          /* style + important beats the CSS default fill so empty stars can be white */
          path.style.setProperty('fill', i < filledCount ? '#e7721b' : '#ffffff', 'important');
          path.style.setProperty('stroke', '#e7721b', 'important');
        }
      }
    }

    function populateSlide(slide, review, productMap, isProductPage) {
      var nameEl = slide.querySelector('.reviewer-display-name');
      var statusEl = slide.querySelector('.reviewer-status');
      var dateEl = slide.querySelector('.review-date');
      var titleEl = slide.querySelector('.review-title');
      var contentEl = slide.querySelector('.review-content');
      var productWrap = slide.querySelector('.reviews-carousel-card-review-product-container');
      var product = productMap[review.product_id];

      if (nameEl) {
        nameEl.textContent = decodeHtmlEntities(
          review.user && review.user.display_name ? review.user.display_name : 'Verified Customer'
        );
      }
      if (statusEl) {
        statusEl.style.visibility = review.verified_buyer ? 'visible' : 'hidden';
      }
      if (dateEl) {
        dateEl.textContent = formatReviewDate(review.created_at);
      }
      if (titleEl) {
        titleEl.textContent = decodeHtmlEntities(review.title || '');
      }
      if (contentEl) {
        contentEl.textContent = decodeHtmlEntities(review.content || '');
      }

      var card = slide.querySelector('.reviews-carousel-card-container');
      if (card) {
        card.removeAttribute('data-rb-card-scrollbar');
        card.style.setProperty('pointer-events', 'none', 'important');
        card.style.setProperty('overflow-y', 'hidden', 'important');
        card.style.setProperty('overflow-x', 'hidden', 'important');
        card.style.setProperty('touch-action', 'pan-y', 'important');
      }

      updateStarRating(slide, review.score || 5);

      if (productWrap) {
        if (isProductPage || !product) {
          productWrap.style.display = 'none';
        } else {
          productWrap.style.display = '';
          var productImage = productWrap.querySelector('.review-product-image');
          var productName = productWrap.querySelector('.review-product-name');
          var productLink = productWrap.querySelector('.review-product');
          if (productImage && product.image_url) {
            productImage.src = product.image_url;
            productImage.alt = decodeHtmlEntities(product.name || '');
          }
          if (productName) {
            var decodedProductName = decodeHtmlEntities(product.name || '');
            productName.textContent = decodedProductName;
            productName.title = decodedProductName;
          }
          if (productLink && product.name) {
            productLink.setAttribute('aria-label', 'Navigate to ' + decodeHtmlEntities(product.name));
          }
        }
      }
    }

    function rebuildSlides(el, reviews, productMap, templateHtml) {
      var slidesEl = getSlidesEl(el);
      if (!slidesEl || !templateHtml || !reviews.length) return false;

      var isProductPage = Boolean(getProductId(el));
      var parser = document.createElement('ul');
      var fragment = document.createDocumentFragment();
      var built = 0;

      reviews.forEach(function (review, index) {
        parser.innerHTML = templateHtml;
        var slide = parser.firstElementChild;
        if (!slide) return;
        slide.classList.remove('glide__slide--clone', 'glide__slide--active');
        slide.removeAttribute('data-slide-id');
        slide.setAttribute('aria-label', 'slide ' + (index + 1) + ' out of ' + reviews.length);
        slide.dataset.rbReviewId = String(review.id);
        populateSlide(slide, review, productMap, isProductPage);
        fragment.appendChild(slide);
        built += 1;
      });

      if (!built) return false;

      slidesEl.innerHTML = '';
      slidesEl.appendChild(fragment);
      fixReviewTextEntities(el);
      /* Fragment is empty after appendChild — count built slides, not fragment.childNodes */
      return built > 0;
    }

    function prefetchReviewSummary(el) {
      if (el.dataset.rbTotalReviews) {
        updateReviewSummary(el, parseInt(el.dataset.rbTotalReviews, 10));
        return;
      }

      fetch(getReviewsApiUrl(getProductId(el)) + '?per_page=1&page=1')
        .then(function (response) {
          if (!response.ok) throw new Error('summary failed');
          return response.json();
        })
        .then(function (payload) {
          var response = payload && payload.response;
          if (!response) return;
          var total = response.pagination && response.pagination.total
            ? response.pagination.total
            : response.bottomline && response.bottomline.total_review
              ? response.bottomline.total_review
              : 0;
          if (!total) return;
          el.dataset.rbTotalReviews = String(total);
          updateReviewSummary(el, total);
        })
        .catch(function () {});
    }

    function getFallbackSlideHtml() {
      var star =
        '<span class="yotpo-star-container">' +
        '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" width="22" height="22" focusable="false">' +
        '<path d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#e7721b" fill="#e7721b"></path>' +
        '</svg></span>';
      var stars = '';
      for (var i = 0; i < 5; i++) stars += star;

      return (
        '<li class="glide__slide">' +
          '<div class="reviews-carousel-card-container">' +
            '<div class="yotpo-review">' +
              '<div class="yotpo-header rb-review-card__header">' +
                '<div class="reviews-carousel-card-reviewer-info-container rb-review-card__meta-row">' +
                  '<div class="reviewer-info">' +
                    '<span class="reviewer-display-name"></span>' +
                    '<span class="reviewer-status">Verified Buyer</span>' +
                  '</div>' +
                  '<span class="review-date"></span>' +
                '</div>' +
                '<div class="yotpo-review-stars rb-review-card__stars">' + stars + '</div>' +
              '</div>' +
              '<div class="content-review rb-review-card__body">' +
                '<div class="review-title"></div>' +
                '<div class="review-content"></div>' +
              '</div>' +
              '<div class="reviews-carousel-card-review-product-container rb-review-card__product">' +
                '<a class="review-product" href="#">' +
                  '<img class="review-product-image" src="" alt="" width="40" height="40" loading="lazy" />' +
                  '<span class="review-product-name"></span>' +
                '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }

    function ensureGlideShell(el) {
      /* Keep our carousel outside Yotpo’s host — Yotpo wipes / rewrites that node */
      hideYotpoHosts(el);

      var host = el.querySelector('[data-rb-reviews-shell]');
      if (!host) {
        host = document.createElement('div');
        host.setAttribute('data-rb-reviews-shell', '1');
        host.setAttribute('data-rb-owns-motion', 'true');
        host.className = 'rb-reviews__native-host';
        el.appendChild(host);
      } else {
        host.setAttribute('data-rb-owns-motion', 'true');
      }

      if (host.querySelector('.glide__slides')) return true;

      host.innerHTML =
        '<div class="yotpo-reviews-carousel-widget-container rb-reviews__native-shell">' +
          '<div class="carousel-display-wrapper">' +
            '<div class="yotpo-carousel">' +
              '<div class="glide">' +
                '<div class="glide__track" data-glide-el="track">' +
                  '<ul class="glide__slides" data-rb-owns-motion="true"></ul>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';

      return Boolean(host.querySelector('.glide__slides'));
    }

    function resolveTemplateHtml(el) {
      var shell = getShell(el);
      var templateSlide = shell ? shell.querySelector('.glide__slide:not(.glide__slide--clone)') : null;
      if (templateSlide) return templateSlide.outerHTML;
      return getFallbackSlideHtml();
    }

    function waitForTemplateSlide(callback, attempts) {
      attempts = attempts || 0;
      var shell = getShell(root);
      var templateSlide = shell ? shell.querySelector('.glide__slide:not(.glide__slide--clone)') : null;
      if (templateSlide) {
        callback(templateSlide.outerHTML);
        return;
      }
      /* Yotpo often never injects Glide — bootstrap after ~1.5s */
      if (attempts >= 6) {
        ensureGlideShell(root);
        callback(getFallbackSlideHtml());
        return;
      }
      window.setTimeout(function () {
        waitForTemplateSlide(callback, attempts + 1);
      }, 250);
    }

    function loadExpandedReviews(el) {
      if (el.dataset.rbReviewsExpanded === '1' || el.dataset.rbReviewsExpanded === 'loading') return;

      function startWithTemplate(templateHtml) {
        if (el.dataset.rbReviewsExpanded === '1' || el.dataset.rbReviewsExpanded === 'loading') return;
        if (!ensureGlideShell(el)) {
          el.dataset.rbReviewsExpanded = '0';
          return;
        }

        el.dataset.rbReviewsExpanded = 'loading';

        fetch(getReviewsApiUrl(getProductId(el)) + '?per_page=' + REVIEWS_FETCH_COUNT + '&page=1')
          .then(function (response) {
            if (!response.ok) throw new Error('reviews failed');
            return response.json();
          })
          .then(function (payload) {
            var response = payload && payload.response;
            if (!response || !response.reviews || !response.reviews.length) {
              el.dataset.rbReviewsExpanded = '0';
              return;
            }

            var total = response.pagination && response.pagination.total
              ? response.pagination.total
              : response.bottomline && response.bottomline.total_review
                ? response.bottomline.total_review
                : response.reviews.length;

            var productMap = buildProductMap(response.products);
            if (!rebuildSlides(el, response.reviews, productMap, templateHtml)) {
              el.dataset.rbReviewsExpanded = '0';
              return;
            }

            el._rbSlideCache = {
              templateHtml: templateHtml,
              reviews: response.reviews,
              productMap: productMap,
              total: total,
            };

            el.dataset.rbReviewsExpanded = '1';
            el.dataset.rbTotalReviews = String(total);
            updateReviewSummary(el, total);
            lastLogicalIndex = 0;
            layoutCarousel(el);
            syncScrollbar(el, 0, false);
            syncSwipeHint(el);
            unlockMobileSwipeSurface(el);
            bindMobileSwipe(el);
          })
          .catch(function () {
            el.dataset.rbReviewsExpanded = '0';
          });
      }

      /* Prefer immediate API path — don't block forever on Yotpo Glide */
      if (getSlidesEl(el) || ensureGlideShell(el)) {
        startWithTemplate(resolveTemplateHtml(el));
        return;
      }

      waitForTemplateSlide(startWithTemplate);
    }

    function bindCarousel(el) {
      if (!el || el.dataset.rbGlideBound === '1') return;
      ensureGlideShell(el);
      if (!getSlidesEl(el)) return;
      el.dataset.rbGlideBound = '1';

      takeControl(el);
      prefetchReviewSummary(el);
      loadExpandedReviews(el);
      layoutCarousel(el);
      window.setTimeout(function () { layoutCarousel(el); }, 400);
      window.setTimeout(function () { layoutCarousel(el); }, 1200);

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
          clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            layoutCarousel(el);
          }, 100);
        }).observe(el);
      } else {
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            layoutCarousel(el);
          }, 100);
        });
      }
    }

    /* Shell first — Yotpo initWidgets can throw and must not block us */
    ensureGlideShell(root);
    try {
      bindCarousel(root);
    } catch (error) {
      root.dataset.rbGlideBound = '0';
    }

    try {
      refreshRbReviewsYotpo();
    } catch (error) {
      /* ignore */
    }

    if (!getSlidesEl(root) && root.dataset.rbMountWatch !== '1') {
      root.dataset.rbMountWatch = '1';
      new MutationObserver(function () {
        if (getSlidesEl(root)) {
          try { bindCarousel(root); } catch (error) { /* ignore */ }
        }
      }).observe(root, { childList: true, subtree: true });
      window.setTimeout(function () {
        if (root.dataset.rbGlideBound === '1') return;
        ensureGlideShell(root);
        try { bindCarousel(root); } catch (error) { /* ignore */ }
      }, 1500);
    }

    /* If Yotpo later wipes our shell, rebuild from API */
    if (root.dataset.rbReviewsGuard !== '1') {
      root.dataset.rbReviewsGuard = '1';
      window.setInterval(function () {
        if (root.dataset.rbReviewsNative === 'true') return;
        hideYotpoHosts(root);
        ensureGlideShell(root);
        var slides = getRealSlides(root);
        if (slides.length > 0 && root.dataset.rbGlideBound === '1' && root.dataset.rbCarouselReady === '1') {
          return;
        }
        root.dataset.rbGlideBound = '0';
        root.dataset.rbReviewsExpanded = '0';
        root.dataset.rbCarouselReady = '0';
        try { bindCarousel(root); } catch (error) { /* ignore */ }
      }, 2500);
    }
  }

  function initAll() {
    document.querySelectorAll('.rb-reviews__yotpo').forEach(initRbReviewsRoot);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector('.rb-reviews__yotpo')) return;
    event.target.querySelectorAll('.rb-reviews__yotpo').forEach(function (root) {
      root.dataset.rbReviewsRootInit = '0';
      root.dataset.rbGlideBound = '0';
      root.dataset.rbMountWatch = '0';
      root.dataset.rbCarouselReady = '0';
      root.dataset.rbAutoplay = '0';
      root.dataset.rbReviewsExpanded = '0';
      root.dataset.rbTransformLock = '0';
      root._rbCarouselState = null;
      if (root._rbYotpoKillTimer) {
        window.clearInterval(root._rbYotpoKillTimer);
        root._rbYotpoKillTimer = null;
      }
    });
    initAll();
  });
})();

/* rb-reviews-home asset */

